export const contactsData = {
    email: 'vivek.arora2024@gmail.com',
    phone: '+91-9414875446',
    address: 'New Delhi, India',
    github: 'https://github.com/vivekarora-02',
    linkedIn: 'https://www.linkedin.com/in/vivekarora02/',
    twitter: 'https://twitter.com/_vivek07',
    medium: 'https://medium.com/@vivek.arora2024',
}